import { useState } from 'react';

const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/d9l03joh9dsfbuoi6l90';

export default function Contact() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotVal = (formData.get('phone_alt') as string || '').trim();
    if (honeypotVal !== '') {
      setStatus('success');
      return;
    }
    formData.delete('phone_alt');

    try {
      const response = await fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败';
        if (typeof msg === 'string' && (msg.includes('spam') || msg.includes('form data is spam'))) {
          setStatus('error');
          setErrorMsg('提交失败，请稍后重试');
        } else {
          setStatus('error');
          setErrorMsg(typeof msg === 'string' ? msg : '提交失败，请稍后重试');
        }
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请检查网络后重试');
    }
  };

  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          爆料投稿
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10">
          发现热门事件？欢迎投稿爆料，优质内容将获得首页推荐
        </p>
        <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/60">
          <div className="flex flex-col md:flex-row gap-8">
            <div className="md:w-1/2">
              <h3 className="text-base font-semibold text-foreground-900 mb-3">投稿须知</h3>
              <ul className="space-y-3 text-sm text-foreground-700">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  <span>请提供真实可靠的热门爆料线索</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  <span>原创内容或独家线索优先处理</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  <span>审核通过后将在 24 小时内上线</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  <span>优质投稿者将获得专属标识</span>
                </li>
              </ul>
              <div className="mt-6 p-4 bg-accent-50 rounded-xl border border-accent-200/60">
                <p className="text-xs text-foreground-600">
                  <i className="ri-mail-line mr-1 text-accent-500"></i>
                  或直接发送邮件至：<span className="font-medium text-foreground-800">tips@51chigua.com</span>
                </p>
              </div>
            </div>

            <div className="md:w-1/2">
              <form
                data-readdy-form
                onSubmit={handleSubmit}
                className="space-y-4"
              >
                <div>
                  <label className="block text-xs font-medium text-foreground-700 mb-1.5">
                    爆料标题 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="title"
                    required
                    placeholder="简要描述你发现的热门事件"
                    className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-foreground-700 mb-1.5">
                    详细描述 <span className="text-primary-500">*</span>
                  </label>
                  <textarea
                    name="description"
                    required
                    rows={4}
                    maxLength={500}
                    placeholder="请详细描述事件经过，可附上相关链接或截图说明"
                    className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 transition-colors resize-none"
                  ></textarea>
                  <p className="text-xs text-foreground-500 mt-1">限 500 字</p>
                </div>
                <div>
                  <label className="block text-xs font-medium text-foreground-700 mb-1.5">
                    你的昵称
                  </label>
                  <input
                    type="text"
                    name="nickname"
                    placeholder="选填，将显示为投稿者名称"
                    className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-foreground-700 mb-1.5">
                    联系邮箱
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder="选填，方便我们联系你确认信息"
                    className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg focus:outline-none focus:border-primary-400 transition-colors"
                  />
                </div>

                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="honeypot-field"
                />

                <button
                  type="submit"
                  className="w-full bg-primary-500 hover:bg-primary-600 text-white font-semibold py-3 rounded-lg text-sm transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-send-plane-line mr-2"></i>提交爆料
                </button>

                {status === 'success' && (
                  <p className="text-sm text-green-600 text-center bg-green-50 py-2 rounded-lg">
                    爆料已成功提交！感谢你的热心投稿，我们的编辑会尽快审核。
                  </p>
                )}
                {status === 'error' && (
                  <p className="text-sm text-red-600 text-center bg-red-50 py-2 rounded-lg">
                    {errorMsg}
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}